import { cn } from "@/lib/utils";
import { image115, imgReporting, imgBrandSafety } from "@/lib/assets";

type ForAgenciesFeatureCardsProps = React.HTMLAttributes<HTMLElement>;

const features = [
  {
    title: "Verification of Views",
    image: image115,
    alt: "Graph showing views from bots versus organic reach over time",
  },
  {
    title: "Enterprise-grade Reporting",
    image: imgReporting,
    alt: "Account-level impact reporting dashboard",
  },
  {
    title: "Brand-safety Safeguards",
    image: imgBrandSafety,
    alt: "Content workflow from upload to publishing with approval steps",
  },
];

export function ForAgenciesFeatureCards({ className, ...props }: ForAgenciesFeatureCardsProps) {
  return (
    <section
      className={cn(
        "rounded-3xl border border-(--card-border-glass) bg-card-surface-veil p-6 text-(--color-text-primary) shadow-card-lg backdrop-blur-md md:p-10",
        className,
      )}
      {...props}
    >
      <div className="flex flex-col items-center gap-6 text-center md:gap-8">
        <h2 className="text-heading-lg text-(--color-text-primary)">Why partner with Evangelist?</h2>
      </div>

      <div className="mx-auto mt-8 grid max-w-7xl gap-6 md:mt-12 md:grid-cols-3">
        {features.map((feature) => (
          <div key={feature.title} className="flex h-full flex-col gap-6 rounded-2xl bg-surface-tertiary p-6 md:p-8">
            <div className="relative aspect-[5/3] w-full overflow-hidden rounded-xl">
              <img
                src={feature.image}
                alt={feature.alt}
                className="block h-full w-full object-cover"
                loading="lazy"
                decoding="async"
              />
            </div>
            <h3 className="text-heading-card text-center text-(--color-text-primary)">{feature.title}</h3>
          </div>
        ))}
      </div>
    </section>
  );
}
